import { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext } from "../App";
import { getTranslatedString } from "./functions/functions";

function PopUps({ hidden }) {
	const { lang, cartVisible, popUps } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const [popUpsVisible, setPopUpsVisible] = useState([]);
	const [cartPopUpsVisible, setCartPopUpsVisible] = useState([]);

	useEffect(() => {
		if (shop && popUps)
			setPopUpsVisible(popUps.filter((p) => p.type != "popup_cart" && p.type != "popup_preorder"));
	}, [lang, popUps]);

	useEffect(() => {
		if (cartVisible && popUps) setCartPopUpsVisible(popUps.filter((p) => p.type == "popup_cart"));
	}, [cartVisible]);

	const handleClose = (n) => {
		setPopUpsVisible(popUpsVisible.filter((el, i) => i != n));
	};

	const handleCloseCart = (n) => {
		setCartPopUpsVisible(cartPopUpsVisible.filter((el, i) => i != n));
	};

	if (hidden) return null;

	return (
		<>
			{popUpsVisible &&
				popUpsVisible.map((p, i) => (
					<div key={i} className="promo-popup">
						<div className="content">
							{p.img && (
								<div className="img">
									<img src={p.img} alt={p.title} />
								</div>
							)}
							<div className="title">{getTranslatedString(p, "title", lang)}</div>
							<div
								dangerouslySetInnerHTML={{
									__html: getTranslatedString(p, "text", lang),
								}}
							/>
							<button onClick={() => handleClose(i)}>
								{getTranslatedString(p, "button_label", lang)}
							</button>
						</div>
					</div>
				))}
			{cartPopUpsVisible &&
				cartPopUpsVisible.map((p, i) => (
					<div key={"cart-" + i} className="promo-popup">
						<div className="content">
							{p.img && (
								<div className="img">
									<img src={p.img} alt={p.title} />
								</div>
							)}
							<div className="title">{getTranslatedString(p, "title", lang)}</div>
							<div
								dangerouslySetInnerHTML={{
									__html: getTranslatedString(p, "text", lang),
								}}
							/>
							<button onClick={() => handleCloseCart(i)}>
								{getTranslatedString(p, "button_label", lang)}
							</button>
						</div>
					</div>
				))}
		</>
	);
}

export default PopUps;
